import React from "react";
import { useParams } from "react-router-dom";

const ProjectDetail = ({ projects }) => {
  const { id } = useParams(); // Get the project's index from URL parameters
  const projectId = parseInt(id, 10); // Convert the index to a number
  const project = projects[projectId];

  return (
    <div>
      <h2>{project.title}</h2>
      <img src={project.imgUrl} alt={project.title} />
      <p>{project.description}</p>
      {/* Add more detailed information here */}
    </div>
  );
};

export default ProjectDetail;
